// show hide answers
document.querySelectorAll('.faq-question').forEach((question) => {
  question.addEventListener('click', () => {
    const answer = question.nextElementSibling;
    answer.classList.toggle('active');
    question.classList.toggle('active');

    if (answer.classList.contains('active')) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    } else {
      answer.style.maxHeight = null;
    }
  });
});
// show hide answers

// Main Seller and Buyer tabs

  document.querySelectorAll('.seller-bayer-questions-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabName = tab.getAttribute('tab-name');

      /* Tabs active state */
      document.querySelectorAll('.seller-bayer-questions-tab').forEach(t => {
        t.classList.remove('active');
      });
      tab.classList.add('active');

      /* FAQ groups toggle */
      document.querySelectorAll('.category-main-group-for-faqs').forEach(group => {
        if (group.getAttribute('category-group') === tabName) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }
      });
    });
  });
// Main Seller and Buyer tabs

// change answers base on category change
 document.addEventListener('click', function (e) {
    const categoryItem = e.target.closest('.category-name');
    if (!categoryItem) return;

    const selectedCategory = categoryItem.getAttribute('category-group');

    /* find active main group (Seller / Buyer) */
    const activeMainGroup = categoryItem.closest('.category-main-group-for-faqs.active');
    if (!activeMainGroup) return;

    /* toggle category-name active */
    activeMainGroup
      .querySelectorAll('.category-name')
      .forEach(item => item.classList.remove('active'));

    categoryItem.classList.add('active');

    /* toggle questions groups */
    activeMainGroup
      .querySelectorAll('.questions-group-for-faqs')
      .forEach(group => {
        if (group.getAttribute('category-group') === selectedCategory) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }
      });
  });
// change answers base on category change